<template>
    <div class="com-richtext-wp ql-container ql-snow">
		<div class="ql-editor">
	       <div v-html="richtext"></div>
	    </div>
	</div>
</template>
<script>
import 'quill/dist/quill.snow.css'
export default {
    data(){
        return{

        }
    },
    props:{
        richtext:{
            default:''
        }
    }
}
</script>

<style lang="scss">
.ql-container.ql-snow{
    border:none;
}
.com-richtext-wp{
    width:100%;
    height:auto;
    // img{
    //     width:80%;
    //     margin-left:10%;
        
    // }
    // p{
    //     line-height: 30px;
    // }
    // li,p,span{
    //     padding:10px 0;
    //     color:#666666!important;
    // }
    
}

</style>